import { IOdataFilter } from './Filter/IOdataFilter';
import { OdataSort } from './Sort/OdataSort';
import { OdataSelect } from './Select/OdataSelect'

export class OdataQuery {
  public filter: IOdataFilter;
  public sort: OdataSort[];
  public page: number;
  public pageSize: number;
  public isCount: boolean;
  public select: OdataSelect[];

  setFilter(filter: IOdataFilter): OdataQuery {
    this.filter = filter;

    return this;
  }

  setPage(page: number): OdataQuery {
    this.page = page;

    return this;
  }

  setPageSize(pageSize: number): OdataQuery {
    this.pageSize = pageSize;

    return this;
  }

  setCount(isCount: boolean): OdataQuery {
    this.isCount = isCount;

    return this;
  }

  addSort(sort: OdataSort): OdataQuery {
    if (!this.sort) {
      this.sort = [sort];
    } else {
      this.sort.push(sort);
    }

    return this;
  }

  addSorts(sorts: OdataSort[]): OdataQuery {
    if (!this.sort) {
      this.sort = sorts.slice(0);
    } else {
      this.sort = this.sort.concat(sorts);
    }

    return this;
  }

  addSelect(select: OdataSelect): OdataQuery {
    if (!this.select) {
      this.select = [select];
    } else {
      this.select.push(select);
    }

    return this;
  }

  addSelects(selects: OdataSelect[]): OdataQuery {
    if (!this.select) {
      this.select = selects.slice(0);
    } else {
      this.select = this.select.concat(selects);
    }

    return this;
  }
}
